<template>
  <div class="bg-agency">
    <el-row>
      <el-col>
        <el-row class="agencyheader">
          <el-col class="logo_agency" :xl="3" :lg="3" :md="9" :sm="9" :xs="9">
            <img
              src="~../../../assets/img/logos/logo.svg"
              alt="TalentSensus"
              class="logo_main"
            />
          </el-col>
        </el-row>
        <el-row class="registration-container">
          <el-col
            class="content-1"
            :offset="3"
            style="height: 100%"
            :xl="9"
            :lg="9"
          >
            <el-row style="height: 100%">
              <el-col>
                <el-row type="flex" justify="center" class="text">
                  <el-col>
                    <h3>
                      Register your Career Center on TalentSens<strong
                        class="us-blue"
                        >us</strong
                      >
                    </h3>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="center" class="text">
                  <el-col>
                    <h5>
                      TalentSensus helps Workforce Career Centers manage
                      jobseeker cases and employer engagement through an
                      intelligent, equitable, multidimensional skills matching
                      platform. Giving Workforce Career Centers the ability to
                      use data and analytics to their advantage, TalentSensus
                      compliments the local workforce system to support, plan
                      and measure talent retention, jobseeker placement, and
                      upskilling for their clients.
                    </h5>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col class="content-2" style="height: 100%" :xl="8" :lg="8">
            <el-form
              label-position="top"
              @submit.native.prevent
              :disabled="isInvalidToken"
            >
              <el-row class="registration-form">
                <el-col>
                  <el-row class="registration-data">
                    <el-col>
                      <el-form-item
                        ref="portal"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PortalDomain.Subdomain'
                          )
                        "
                        :required="true"
                        label="Portal"
                      >
                        <el-input v-model="agency.portalDomain.subdomain">
                          <template slot="append">.talentsensus.com</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="registration-data" :gutter="20">
                    <el-col :xl="12" :lg="12">
                      <el-form-item
                        ref="email"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PersonalDetails.CompanyEmail'
                          )
                        "
                        :required="true"
                        label="Email"
                      >
                        <el-input
                          v-model="agency.personalDetails.companyEmail"
                          placeholder="Company Email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xl="12" :lg="12">
                      <el-form-item :required="true" label="Company phone">
                        <PhoneNumber
                          ref="phoneNumberComponent"
                          :ModelState="modelState"
                          @phone-input="handlePhoneInput"
                          @intl-code-selected="handleIntlCodeSelected"
                          @phone-country-code-selected="
                            handlePhoneCountryCodeSelected
                          "
                          PhoneCodeField="CompanyDetails.CountryInternationalCode"
                          PhoneNumberField="CompanyDetails.TelephoneNumber"
                        >
                        </PhoneNumber>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row
                    class="registration-data"
                    :gutter="20"
                    style="padding-top: 13px"
                  >
                    <el-col :xl="12" :lg="12">
                      <el-form-item
                        ref="firstname"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PersonalDetails.FirstName'
                          )
                        "
                        :required="true"
                        label="First Name"
                      >
                        <el-input
                          v-model="agency.personalDetails.firstName"
                          placeholder="First Name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xl="12" :lg="12">
                      <el-form-item
                        ref="surname"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PersonalDetails.Surname'
                          )
                        "
                        :required="true"
                        label="Last Name"
                      >
                        <el-input
                          v-model="agency.personalDetails.surname"
                          placeholder="Last Name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row class="registration-data" :gutter="20">
                    <el-col :xl="12" :lg="12">
                      <el-form-item
                        ref="password"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PersonalDetails.Password'
                          )
                        "
                        :required="true"
                        label="Password"
                      >
                        <el-input
                          placeholder="Choose a password"
                          v-model="agency.personalDetails.password"
                          show-password
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xl="12" :lg="12">
                      <el-form-item
                        ref="confirmpassword"
                        :error="
                          retrieveFieldError(
                            modelState,
                            'PersonalDetails.ConfirmPassword'
                          ) ||
                            retrieveFieldError(
                              modelState,
                              'PersonalDetails.Password.ConfirmPassword'
                            )
                        "
                        :required="true"
                        label="Confirm Password"
                      >
                        <el-input
                          placeholder="Confirm password"
                          v-model="agency.personalDetails.confirmPassword"
                          show-password
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-alert
                    title="Password needs to have Capital Letter, Number, and Special Character."
                    type="info"
                    show-icon
                    :closable="false"
                  >
                  </el-alert>

                  <PasswordChecklist
                    v-if="passwordCriteriaResult.length > 0"
                    :Data="passwordCriteriaResult"
                  ></PasswordChecklist>

                  <el-row
                    class="registration-data"
                    type="flex"
                    align="middle"
                    justify="center"
                    style="padding-bottom: 10px"
                  >
                    <el-col>
                      <el-button
                        :disabled="isInvalidToken"
                        @click="registerAgency"
                        >Signup</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-row style="text-align: center" class="registration-data">
                    <el-col>
                      <el-link href="/login"
                        >Already have an account? <i>Login here</i></el-link
                      >
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
      <div class="agency-footer">
        <p>© {{ appYear }} TalentSensus Inc. All Rights Reserved</p>
      </div>
    </el-row>
    <!-- <loading 
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import PasswordChecklist from "../../jobseeker/components/PasswordChecklist.vue";
import PhoneNumber from "../../../components/PhoneNumber";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    PasswordChecklist,
    PhoneNumber,
    TSLoading
  },
  data() {
    return {
      agency: {
        personalDetails: {},
        portalDomain: {},
        companyDetails: {}
      },
      modelState: {},
      isLoading: false,
      token: "",
      agencyApplication: {},
      isInvalidToken: false,
      registration: {
        token: ""
      },
      passwordCriteriaResult: [],
      selectedPhoneCode: "+1",
      phoneNumber: "",
      selectedPhoneCountryCode: "US"
    };
  },
  watch: {
    "agency.portalDomain.subdomain": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("portal");
      }
    },
    "agency.personalDetails.firstName": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("firstname");
      }
    },
    "agency.personalDetails.surname": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("surname");
      }
    },
    "agency.personalDetails.companyEmail": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("email");
      } else {
        this.agency.personalDetails.companyEmail = undefined;
      }
    },
    "agency.personalDetails.password": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("password");
      }
    },
    "agency.personalDetails.confirmPassword": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("confirmpassword");
      }
    },
    "agency.telephoneNumber": function(newValue, oldValue) {
      // eslint-disable-line
      if (newValue != "") {
        this.clearValidation("phonenumber");
      }
    }
  },
  updated() {
    const elements = document.getElementsByClassName("el-form-item__error");
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.color = "#F56C6C";
      if (elements[i].innerText.indexOf(",") != -1) {
        elements[i].style.color =
          this.passwordCriteriaResult.length > 0
            ? "rgba(128, 128, 128, 0)"
            : "#F56C6C";
      }
    }

    const container = document.getElementsByClassName("registration-form");
    for (var i = 0; i < container.length; i++) {
      container[i].style.height =
        this.passwordCriteriaResult.length > 0 ? "650px" : "500px";
    }
  },
  methods: {
    registerAgency() {
      this.isLoading = true;
      this.modelState = {};
      this.agency.companyDetails.organisationType = 1;
      this.agency.companyDetails.telephoneCountryCode = this.selectedPhoneCountryCode;
      this.agency.companyDetails.countryInternationalCode = this.selectedPhoneCode;
      this.agency.companyDetails.telephoneNumber =
        this.phoneNumber === ""
          ? ""
          : this.selectedPhoneCode + " " + this.phoneNumber;
      this.$store
        .dispatch("registration/register", this.agency)
        .then(res => {
          this.agency = {
            personalDetails: {
              companyEmail: "",
              firstName: "",
              surname: "",
              password: "",
              confirmPassword: ""
            },
            companyDetails: {
              telephoneNumber: "",
              countryInternationalCode: "",
              telephoneCountryCode: ""
            },
            portalDomain: {
              subdomain: ""
            }
          };
          this.passwordCriteriaResult = [];
          if (this.$refs.phoneNumberComponent) {
            this.$refs.phoneNumberComponent.reset();
          }
          this.modelState = {};
          this.isLoading = false;
          this.$message.success("Career Center creation successful.");
        })
        .catch(res => {
          this.passwordCriteriaResult = [];
          if (res.errors !== undefined) {
            let password = res.errors['PersonalDetails.Password'];
            if (password) {
              if (password.find((c) => c.indexOf(",") != -1)) {
                this.passwordCriteriaResult = password;
                res.errors['PersonalDetails.Password'] = [];
              }
            }          
          }
          
          this.modelState = res.errors;
          this.isLoading = false;
        });
    },
    clearValidation(field) {
      this.$refs[field].clearValidate();
    },
    handlePhoneInput(value) {
      this.phoneNumber = value;
    },
    handleIntlCodeSelected(value) {
      this.selectedPhoneCode = value;
    },
    handlePhoneCountryCodeSelected(value) {
      this.selectedPhoneCountryCode = value;
    }
  },
  computed: {
    appYear() {
      return process.env.VUE_APP_YEAR;
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/project/agencyregistration.scss";
</style>
